import React from 'react';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { SecondaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import { withLocalePrefix } from 'shared/utils/translation';
import BookmarkIcon from 'shared/components/birch/icons/bookmark';
import BookmarkFilledIcon from 'shared/components/birch/icons/bookmark_filled';

const t = withLocalePrefix('talent_matching.filter_row.saved_for_later');

const SavedForLater = () => {
  const { watch, setValue } = useFormContext();
  const savedForLater = watch('savedForLater');

  const Icon = savedForLater ? BookmarkFilledIcon : BookmarkIcon;

  return (
    <SecondaryButton
      size="md"
      icon={Icon}
      onClick={() =>
        setValue('savedForLater', !savedForLater, { shouldDirty: true })
      }
    >
      {t('title')}
    </SecondaryButton>
  );
};

export default SavedForLater;
